<!-- Sidebar -->
<div [class.opened]="isSideMenuOpened"
     class="side-bar-menu hidden-print hide-scrollbar"
     id="sidebar-wrapper">
    <ul class="sidebar-nav">
        <li class="sidebar-trigger">
            <div [class.is-active]="isSideMenuOpened"
                 class="hamburger">
                <div (click)="ToggleClass()"
                     class="hamburger-box">
                    <div class="hamburger-inner"></div>
                </div>
            </div>
        </li>

        <li class="sidebar-menu-wrapper"
            tabindex="0">
            <a [ngClass]="{'active-menu': dashboardMenuActive}"
               href="#"
               matTooltip="{{ isSideMenuOpened ? null: 'Home' | translate }}"
               matTooltipClass="sidenav-tooltip"
               matTooltipPosition="right"
               routerLink="/dashboard">
                <!--<mat-icon>home</mat-icon>-->
                <img *ngIf="!dashboardMenuActive"
                     alt="home"
                     class="menu-icon"
                     height="22"
                     ngSrc="assets/icons/home_default.svg"
                     width="21"/>
                <img *ngIf="dashboardMenuActive"
                     alt="home"
                     class="menu-icon"
                     height="21"
                     ngSrc="assets/icons/home_select.svg"
                     width="21"/>
                <span class="">{{ 'siteMenu.home'|translate }}</span>
            </a>
        </li>
        <!-- <li class="sidebar-menu-wrapper" tabindex="0">
            <a href="#" routerLink="/dw-dashboard" [ngClass]="{'active-menu': dashboardMenuActive}"
                matTooltip="{{ isOpened ? null: 'Home' | translate }}" matTooltipClass="sidenav-tooltip"
                matTooltipPosition="right">
             
                <img *ngIf="!dashboardMenuActive" class="menu-icon" id="homeIcon_default"
                    src="../../../../assets/icons/home_default.svg" alt="home" />
                <img *ngIf="dashboardMenuActive" class="menu-icon" id="homeIcon_default"
                    src="../../../../assets/icons/home_select.svg" alt="home" />
                <span class="">{{'siteMenu.home'|translate}}</span>
            </a>
        </li> -->
        <li class="sidebar-menu-wrapper"
            tabindex="0">
            <a (click)="ShowShip($event)"
               *ngIf="showShipNav()"
               [class.opened]="showShip"
               [ngClass]="{'active-menu': shipMenuActive}"
               class="has-submenu"
               href="#"
               matTooltip="{{ isSideMenuOpened ? null: 'siteMenu.ship.groupName'| translate }}"
               matTooltipClass="sidenav-tooltip"
               matTooltipPosition="right">
                <!--<mat-icon>settings</mat-icon>-->
                <img *ngIf="!shipMenuActive && !showShip"
                     alt="ship"
                     class="menu-icon"
                     height="16"
                     id="shipIcon_default"
                     ngSrc="assets/icons/ship_default.svg"
                     width="18"/>
                <img *ngIf="shipMenuActive || showShip"
                     alt="ship"
                     class="menu-icon"
                     height="16"
                     ngSrc="assets/icons/ship_active.svg"
                     width="18"/>
                <span class="">{{ 'siteMenu.ship.groupName'|translate }}</span>
            </a>
            <ul [class.active]="showShip"
                class="sidebar-submenu">
                <li *ngIf="userRoutes?.ShipUPS"
                    [ngClass]="{active : (this.router.url.includes('/ship/ups') && !this.router.url.includes('return-shipment')) }"
                    tabindex="0">
                    <a routerLink="/ship/ups">
                        {{ 'siteMenu.ship.shipUps' | translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.ShipFedex"
                    [ngClass]="{active : this.router.url.includes('/ship/fedex')}"
                    tabindex="0">
                    <a routerLink="/ship/fedex">
                        {{ 'siteMenu.ship.shipFedEx' | translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.RecentShipment && !isEUUser()"
                    [ngClass]="{active : this.router.url.includes('pending-shipments')}"
                    tabindex="0">
                    <a class="text-nowrap"
                       routerLink="/pending-shipments">
                        {{ 'siteMenu.ship.pendingShipments'|translate }}
                    </a>
                </li>
                <li *ngIf="environment.feature.reportShipmentsBulkUpload && userRoutes?.ShipReport"
                    [ngClass]="{active : this.router.url.includes('report-shipments')}"
                    tabindex="0">
                    <a class="text-nowrap"
                       routerLink="/report-shipments-upload">
                        {{ 'siteMenu.ship.reportShipments'|translate }} <span class="worldship-badge"> + WorldShip</span>
                    </a>
                </li>
                <li *ngIf="!environment.feature.reportShipmentsBulkUpload && userRoutes?.ShipReport"
                    [ngClass]="{active : this.router.url.includes('report-shipments')}"
                    tabindex="0">
                    <a class="text-nowrap"
                       routerLink="/report-shipments">
                        {{ 'siteMenu.ship.reportShipments'|translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.SavedQuotes"
                    [ngClass]="{active:this.router.url.includes('saved-quotes')}"
                    tabindex="0">
                    <a routerLink="/saved-quotes">
                        {{ 'siteMenu.ship.savedQuotes'|translate }}
                    </a>
                </li>
                <li *ngIf="!environment.feature.reportShipmentsBulkUpload && userRoutes?.WorldShipUpload"
                    [ngClass]="{active : this.router.url.includes('world-ship-upload')}"
                    tabindex="0">

                    <a routerLink="/world-ship-upload">
                        {{ 'siteMenu.ship.worldShipUpload' | translate }}
                    </a>
                </li>
                <li *ngIf="isEUUser()"
                    [ngClass]="{active : this.router.url.includes('return-shipment')}"
                    tabindex=0>
                    <a routerLink="/ship/ups/return-shipment">
                        {{ 'siteMenu.ship.returnShipment' | translate }}
                    </a>
                </li>
            </ul>
        </li>
        <li class="sidebar-menu-wrapper"
            tabindex="0">
            <a (click)="ShowTrack()"
               *ngIf="showTrackNav()"
               [class.opened]="showTrack"
               [ngClass]="{'active-menu': trackMenuActive}"
               class="has-submenu"
               href="javascript:"
               matTooltip="{{ isSideMenuOpened ? null: 'siteMenu.track.groupName' | translate }}"
               matTooltipClass="sidenav-tooltip"
               matTooltipPosition="right">
                <!--<mat-icon>track_changes</mat-icon>-->
                <img *ngIf="!trackMenuActive && !showTrack"
                     alt="track"
                     class="menu-icon"
                     height="22"
                     id="trackIcon_default"
                     ngSrc="assets/icons/track_default.svg"
                     width="22"/>
                <img *ngIf="trackMenuActive || showTrack"
                     alt="track"
                     class="menu-icon"
                     height="22"
                     ngSrc="assets/icons/track_active.svg"
                     width="22"/>
                <span class="">{{ 'siteMenu.track.groupName'|translate }}</span>
            </a>
            <ul [class.active]="showTrack"
                class="sidebar-submenu">
                @if (user.CountryCode === 'US') {
                    <li [ngClass]="{active : this.router.url.includes('track-shipments')}"
                        tabindex="0"
                        *ngIf="userRoutes?.TrackShipments">
                        <a routerLink="/track-shipments">
                            {{ 'siteMenu.track.trackShipments'|translate }}
                            <!--                            <span class="new-text">{{ 'siteMenu.support.new'|translate }}</span>-->
                        </a>
                    </li>
                }

                <li *ngIf="userRoutes?.ShipmentHistory"
                    [ngClass]="{active : this.router.url.includes('shipment-history')}"
                    tabindex="0">
                    <a routerLink="/shipment-history">
                        {{ 'siteMenu.track.shipmentHistory'|translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.ReportHistory"
                    [ngClass]="{active : this.router.url.includes('report-history')}"
                    tabindex="0">
                    <a routerLink="/report-history">
                        {{ 'siteMenu.track.reportHistory'|translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.SchedulePickup"
                    [ngClass]="{active:this.router.url.includes('schedule-pickups')}"
                    tabindex="0">
                    <a routerLink="/schedule-pickups">
                        {{ 'siteMenu.track.scheduledPickups'|translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.EndOfDayReports"
                    [ngClass]="{active:this.router.url.includes('end-of-day-reports')}"
                    tabindex="0">
                    <a routerLink="/reports/end-of-day-reports">
                        {{ 'siteMenu.track.endOfDayReports' | translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.PackageInvestigation"
                    [ngClass]="{active : this.router.url.includes('package-investigation')}"
                    tabindex="0">
                    <a routerLink="/claims">
                        {{ 'siteMenu.track.packageInvestigation'|translate }}
                    </a>
                </li>
            </ul>
        </li>

        <li class="sidebar-menu-wrapper" tabindex="0">
            <a (click)="ShowRiskMitigation()"
               *ngIf="showRiskMitigationNav()"
               [class.opened]="showRiskMitigation"
               [ngClass]="{'active-menu': riskMitigationMenuActive}"
               class="has-submenu"
               href="javascript:"
               matTooltip="{{ isSideMenuOpened ? null: ('siteMenu.risk.groupNameClaims'|translate) + ' & ' + ('siteMenu.risk.groupNameRisk'|translate) }}"
               matTooltipClass="sidenav-tooltip"
               matTooltipPosition="right">
                <!--<mat-icon>track_changes</mat-icon>-->
                <img *ngIf="!riskMitigationMenuActive && !showRiskMitigation"
                     alt="track"
                     class="menu-icon"
                     height="22"
                     id="riskIcon_default"
                     ngSrc="assets/icons/risk--inactive.svg"
                     width="22"/>
                <img *ngIf="riskMitigationMenuActive || showRiskMitigation"
                     alt="track"
                     class="menu-icon"
                     height="22"
                     ngSrc="assets/icons/risk.svg"
                     width="22"/>
                <span class="group-name" badge="New">
                    
                <span>{{ 'siteMenu.risk.groupNameClaims'|translate }}</span>
                    
                    @if (user?.CountryCode === 'US' && customer?.DDEnabled !== null) {
                        <span>&nbsp;&&nbsp;</span>
                        <span>{{ 'siteMenu.risk.groupNameRisk'|translate }}</span>
                    }
                </span>
            </a>
            <ul [class.active]="showRiskMitigation"
                class="sidebar-submenu">
                @if (environment.feature.claims.dashboard) {
                    <li *ngIf="userRoutes?.Claims"
                        [ngClass]="{active : this.router.url.includes('claims')}"
                        tabindex="0">
                        <a routerLink="/claims" badge="New">
                            {{ 'siteMenu.risk.claimsCenter' | translate }}
                        </a>
                    </li>
                }

                @if (user?.CountryCode === 'US' && customer?.DDEnabled !== null) {
                    <li class="sidebar-menu-wrapper"
                        tabindex="0">
                        <a (click)="ShowDeliverDefense()"
                           *ngIf="showDeliveryDefenseNav()"
                           [class.opened]="showDeliveryDefense"
                           [ngClass]="{'active-menu': deliveryDefenseMenuActive}"
                           class="has-submenu"
                           href="javascript:"
                           matTooltip="{{ isSideMenuOpened ? null: 'siteMenu.deliverydefense.groupName' | translate }}"
                           matTooltipClass="sidenav-tooltip"
                           matTooltipPosition="right">
                            <img *ngIf="!deliveryDefenseMenuActive && !showDeliveryDefense"
                                 alt="deliveryDefense"
                                 class="menu-icon"
                                 height="23"
                                 ngSrc="assets/icons/Shield.svg"
                                 width="20"/>
                            <img *ngIf="deliveryDefenseMenuActive || showDeliveryDefense"
                                 alt="deliveryDefense"
                                 class="menu-icon"
                                 height="23"
                                 ngSrc="assets/icons/Shield active.svg"
                                 width="20"/>
                            <span style="margin-top:-1em"> DeliveryDefense <sup style="font-size: 10px; margin-left: -3px;">TM</sup><br> </span>
                            <span style="font-size: 15px; margin-top: 1.1em;">Address Confidence</span>
                        </a>

                        <ul [class.active]="showDeliveryDefense"
                            class="sidebar-submenu">
                            <li *ngIf="userRoutes?.DeliveryDefenseSignUp && canSignUpDD"
                                [ngClass]="{active : this.router.url.includes('delivery-defense-sign-up')}"
                                tabindex="0">
                                <a routerLink="/delivery-defense-sign-up"> {{ 'siteMenu.deliverydefense.deliverySignUp'|translate }} </a>
                            </li>

                            <!-- TODO: For links below that are using this.isDDEnabled value, it causes a minor issue in which the links in the sidebar render late -->
                            <li *ngIf="appState.customer$().DDEnabled === true && isOfficialDDSubscriber"
                                [ngClass]="{active: this.router.url.includes('address-confidence-tool')}"
                                tabindex="0">
                                <a routerLink="/address-confidence-tool"> {{ 'siteMenu.deliverydefense.addressConfidenceTool'|translate }} </a>
                            </li>
                            <li *ngIf="appState.customer$().DDEnabled === true && isOfficialDDSubscriber"
                                [ngClass]="{active: this.router.url.includes('score-history')}"
                                tabindex="0">
                                <a routerLink="/score-history"> {{ 'siteMenu.deliverydefense.scoreHistory'|translate }} </a>
                            </li>
                            <li *ngIf="appState.customer$().DDEnabled === true && userRoutes?.ManageSubscriptions && isOfficialDDSubscriber"
                                [ngClass]="{active: this.router.url.includes('manage-subscription')}"
                                tabindex="0">
                                <a routerLink="/manage-subscription"> {{ 'siteMenu.deliverydefense.manageSubscriptions'|translate }} </a>
                            </li>
                            <li *ngIf="userRoutes?.DeliveryDefenseFAQ"
                                [ngClass]="{active: this.router.url.includes('delivery-defense-faq')}"
                                tabindex="0">
                                <a routerLink="/delivery-defense-faq"> {{ 'siteMenu.deliverydefense.deliveryFAQ'|translate }} </a>
                            </li>
                        </ul>
                    </li>
                }
            </ul>
        </li>

        <!-- Delivery Defense Start-->
        <li *ngIf="user?.CountryCode === 'US' && customer?.DDEnabled !== null && false"
            class="sidebar-menu-wrapper"
            tabindex="0">
            <a (click)="ShowDeliverDefense()"
               *ngIf="showDeliveryDefenseNav()"
               [class.opened]="showDeliveryDefense"
               [ngClass]="{'active-menu': deliveryDefenseMenuActive}"
               class="has-submenu"
               href="javascript:"
               matTooltip="{{ isSideMenuOpened ? null: 'siteMenu.deliverydefense.groupName' | translate }}"
               matTooltipClass="sidenav-tooltip"
               matTooltipPosition="right">
                <img *ngIf="!deliveryDefenseMenuActive && !showDeliveryDefense"
                     alt="deliveryDefense"
                     class="menu-icon"
                     height="23"
                     ngSrc="assets/icons/Shield.svg"
                     width="20"/>
                <img *ngIf="deliveryDefenseMenuActive || showDeliveryDefense"
                     alt="deliveryDefense"
                     class="menu-icon"
                     height="23"
                     ngSrc="assets/icons/Shield active.svg"
                     width="20"/>
                <span style="margin-top:-1em"> DeliveryDefense <sup style="font-size: 10px; margin-left: -3px;">TM</sup><br> </span>
                <span style="font-size: 15px; margin-top: 1.1em;">Address Confidence</span>
            </a>

            <ul [class.active]="showDeliveryDefense"
                class="sidebar-submenu">
                <li *ngIf="userRoutes?.DeliveryDefenseSignUp && (this.currentSubType)"
                    [ngClass]="{active : this.router.url.includes('delivery-defense-sign-up')}"
                    tabindex="0">
                    <a routerLink="/delivery-defense-sign-up"> {{ 'siteMenu.deliverydefense.deliverySignUp'|translate }} </a>
                </li>

                <!-- TODO: For links below that are using this.isDDEnabled value, it causes a minor issue in which the links in the sidebar render late -->
                <li *ngIf="appState.customer$().DDEnabled === true && isOfficialDDSubscriber"
                    [ngClass]="{active: this.router.url.includes('address-confidence-tool')}"
                    tabindex="0">
                    <a routerLink="/address-confidence-tool"> {{ 'siteMenu.deliverydefense.addressConfidenceTool'|translate }} </a>
                </li>
                <li *ngIf="appState.customer$().DDEnabled === true && isOfficialDDSubscriber"
                    [ngClass]="{active: this.router.url.includes('score-history')}"
                    tabindex="0">
                    <a routerLink="/score-history"> {{ 'siteMenu.deliverydefense.scoreHistory'|translate }} </a>
                </li>
                <li *ngIf="appState.customer$().DDEnabled === true && userRoutes?.ManageSubscriptions && isOfficialDDSubscriber"
                    [ngClass]="{active: this.router.url.includes('manage-subscription')}"
                    tabindex="0">
                    <a routerLink="/manage-subscription"> {{ 'siteMenu.deliverydefense.manageSubscriptions'|translate }} </a>
                </li>
                <li *ngIf="userRoutes?.DeliveryDefenseFAQ"
                    [ngClass]="{active: this.router.url.includes('delivery-defense-faq')}"
                    tabindex="0">
                    <a routerLink="/delivery-defense-faq"> {{ 'siteMenu.deliverydefense.deliveryFAQ'|translate }} </a>
                </li>
            </ul>
        </li>
        <!-- Delivery Defense End-->

        <!--#region E-Commerce -->
        @if (environment.feature?.orderManagement?.core && userRoutes?.ECommerce) {
            <li class="sidebar-menu-wrapper"
                tabindex="0">
                <a class="has-submenu"
                   [class.opened]="showECommerce"
                   [class.active-menu]="eCommerceMenuActive"
                   matTooltip="{{ isSideMenuOpened ? null : 'siteMenu.eCommerce.groupName' | translate }}"
                   matTooltipPosition="right"
                   matTooltipClass="sidenav-tooltip"
                   (click)="toggleECommerceMenu($event)">
                    <img [ngSrc]="showECommerce || eCommerceMenuActive ? 'assets/images/e-commerce-selected.svg' : 'assets/images/e-commerce.svg'"
                         class="menu-icon"
                         alt="{{ 'siteMenu.eCommerce.groupName' | translate }}"
                         height="21"
                         width="20">
                    <span>{{ 'siteMenu.eCommerce.groupName' | translate }}</span>
                </a>

                <ul class="sidebar-submenu"
                    [class.active]="showECommerce">
                    <li [class.active]="this.router.url.includes('e-commerce/order-management')"
                        tabindex="0">
                        <a routerLink="/e-commerce/order-management">
                            {{ 'siteMenu.eCommerce.orderManagement' | translate }}
                        </a>
                    </li>
                    <li [class.active]="this.router.url.includes('e-commerce/settings')"
                        tabindex="0">
                        <a routerLink="/e-commerce/settings">
                            {{ 'siteMenu.eCommerce.settings' | translate }}
                        </a>
                    </li>
                    <li [class.active]="this.router.url.includes('e-commerce/faq')"
                        tabindex="0">
                        <a routerLink="/e-commerce/faq">
                            {{ 'siteMenu.eCommerce.faq' | translate }}
                        </a>
                    </li>
                </ul>
            </li>
        }
        <!--#endregion E-Commerce -->

        <li class="sidebar-menu-wrapper"
            tabindex="0">
            <a (click)="ShowBilling()"
               *ngIf="showBillingNav()"
               [class.opened]="showBilling"
               [ngClass]="{'active-menu': billingMenuActive}"
               class="has-submenu"
               href="javascript:"
               matTooltip="{{ isSideMenuOpened ? null: 'siteMenu.billing.groupName' | translate }}"
               matTooltipClass="sidenav-tooltip"
               matTooltipPosition="right">
                <!--<mat-icon>receipt</mat-icon>-->
                <img *ngIf="!billingMenuActive && !showBilling"
                     alt="billing"
                     class="menu-icon"
                     height="16"
                     id="billingIcon_default"
                     ngSrc="assets/icons/billing_default.svg"
                     width="24"/>
                <img *ngIf="billingMenuActive || showBilling"
                     alt="billing"
                     class="menu-icon"
                     height="15"
                     ngSrc="assets/icons/billing_active.svg"
                     width="24"/>
                <span class=""> {{ 'siteMenu.billing.groupName'|translate }} </span>
            </a>
            <ul [class.active]="showBilling"
                class="sidebar-submenu">
                <li *ngIf="userRoutes?.BillingHistory"
                    [ngClass]="{active : this.router.url.includes('billing-history')}"
                    tabindex="0">
                    <a routerLink="/billing-history">
                        {{ 'siteMenu.billing.billingHistory'|translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.PaymentHistory"
                    [ngClass]="{active : this.router.url.includes('payment-history')}"
                    tabindex="0">
                    <a routerLink="/payment-history">
                        {{ 'siteMenu.billing.paymentHistory'|translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.ManageCreditCard"
                    [ngClass]="{active : this.router.url.includes('manage-credit-card')}"
                    tabindex="0">
                    <a routerLink="/manage-credit-card">
                        {{ 'siteMenu.billing.manageCreditCards'|translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.CreditHistory"
                    [ngClass]="{active : this.router.url.includes('credit-history')}"
                    tabindex="0">
                    <a routerLink="/credit-history">
                        {{ 'siteMenu.billing.creditHistory'|translate }}
                    </a>
                </li>
            </ul>
        </li>
        <!-- claims tab starts here-->
        <!-- <li class="sidebar-menu-wrapper" tabindex="0">
       <a class="has-submenu" [class.opened]="showClaim" *ngIf="true"
            [ngClass]="{'active-menu': claimMenuActive}" href="javascript:" (click)="ShowClaims($event)"
            matTooltip="{{ isOpened ? null: 'Claims'  }}"
            matTooltipClass="sidenav-tooltip" matTooltipPosition="right">               
            <img *ngIf="!addressMenuActive && !showAddressBook" class="menu-icon" id="addressBookIcon_default"
                src="" alt="" />
            <img *ngIf="addressMenuActive || showAddressBook" class="menu-icon"
                src="" alt="" />
            <span class=""> Claims </span> </a>
    <ul class="sidebar-submenu" [class.active]="showClaim">
        <li [ngClass]="{active : this.router.url.includes('file-claim')}" tabindex="0">
        <a routerLink="/file-claim">File a Claim</a>
        </li>
        <li [ngClass]="{active : this.router.url.includes('claims-dashboard')}" tabindex="0">
        <a  routerLink="/claims-dashboard">Claim Status</a>
       </li>
        <li [ngClass]="{active : this.router.url.includes('claim-faq')}"  tabindex="0"
        *ngIf="userRoutes?.ClaimFAQ">
        <a routerLink="/claim-faq">
            Claims FAQ
        </a>
        </li>
    </ul>
</li>  -->
        <!-- claims tab ends here -->
        <li class="sidebar-menu-wrapper"
            tabindex="0">
            <a (click)="ShowAddressBook($event)"
               *ngIf="showAddressBookNav()"
               [class.opened]="showAddressBook"
               [ngClass]="{'active-menu': addressMenuActive}"
               class="has-submenu"
               href="javascript:"
               matTooltip="{{ isSideMenuOpened ? null: 'siteMenu.addressBook.groupName' | translate }}"
               matTooltipClass="sidenav-tooltip"
               matTooltipPosition="right">
                <!--<mat-icon>contacts</mat-icon>-->
                <img *ngIf="!addressMenuActive && !showAddressBook"
                     alt="address book"
                     class="menu-icon"
                     height="22"
                     ngSrc="assets/icons/address_default.svg"
                     width="21"/>
                <img *ngIf="addressMenuActive || showAddressBook"
                     alt="address book"
                     class="menu-icon"
                     height="22"
                     ngSrc="assets/icons/address_active.svg"
                     width="20"/>
                <span class=""> {{ 'siteMenu.addressBook.groupName'|translate }} </span> </a>
            <ul [class.active]="showAddressBook"
                class="sidebar-submenu">
                <li *ngIf="userRoutes?.AddressBook"
                    [ngClass]="{active : this.router.url.includes('address-book')}"
                    tabindex="0">
                    <a routerLink="/address-book">
                        {{ 'siteMenu.addressBook.addressBook'|translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.ManageLocations"
                    [ngClass]="{active : this.router.url.includes('manage-locations')}"
                    tabindex="0">
                    <a routerLink="/manage-locations">
                        {{ 'siteMenu.addressBook.manageShipFromLocations'|translate }}
                    </a>
                </li>
            </ul>
        </li>

        @if (false && environment.feature.claims.dashboard) {
            <li class="sidebar-menu-wrapper"
                tabindex="0">
                <a (click)="ShowClaims($event)"
                   *ngIf="showClaimsNav()"
                   [class.opened]="showClaims"
                   [ngClass]="{'active-menu': claimMenuActive}"
                   class="has-submenu"
                   href="javascript:"
                   matTooltip="{{ isSideMenuOpened ? null: 'siteMenu.claims.groupName' | translate }}"
                   matTooltipClass="sidenav-tooltip"
                   matTooltipPosition="right">
                    <!--<mat-icon>contacts</mat-icon>-->
                    <img *ngIf="!claimMenuActive && !showClaims"
                         alt="Claims"
                         class="menu-icon"
                         height="22"
                         ngSrc="assets/icons/claims_active.svg"
                         width="21"/>
                    <img *ngIf="claimMenuActive || showClaims"
                         alt="Claims"
                         class="menu-icon"
                         height="22"
                         ngSrc="assets/icons/claims_active.svg"
                         width="20"/>
                    <span class=""> {{ 'siteMenu.claims.groupName'|translate }} </span> </a>
                <ul [class.active]="showClaims"
                    class="sidebar-submenu">
                    @if (environment.feature.claims.dashboard) {
                        <li [ngClass]="{active : this.router.url.includes('claims/dashboard')}"
                            tabindex="0">
                            <a routerLink="/claims/dashboard">
                                {{ 'siteMenu.claims.dashboard' | translate }}
                            </a>
                        </li>
                    }
                    @if (environment.feature.claims.fileClaim) {
                        <li [ngClass]="{active : this.router.url.includes('claims/file-claim')}"
                            tabindex="0">
                            <a routerLink="/claims/file-claim">
                                {{ 'siteMenu.claims.fileClaim' | translate }}
                            </a>
                        </li>
                    }
                    @if (environment.feature.claims.messenger) {
                        <li [ngClass]="{active : this.router.url.includes('claims/message-center')}"
                            tabindex="0">
                            <a routerLink="/claims/message-center">
                                {{ 'siteMenu.claims.messageCenter' | translate }}
                            </a>
                        </li>
                    }
                    @if (environment.feature.claims.faq) {
                        <li [ngClass]="{active : this.router.url.includes('claims/faq')}"
                            tabindex="0">
                            <a routerLink="/claims/faq">
                                {{ 'siteMenu.claims.faq' | translate }}
                            </a>
                        </li>
                    }
                </ul>
            </li>
        }

        <li class="sidebar-menu-wrapper"
            tabindex="0">
            <a (click)="ShowAccount()"
               *ngIf="showAccountNav()"
               [class.opened]="showAccount"
               [ngClass]="{'active-menu': accountMenuActive}"
               class="has-submenu"
               href="javascript:"
               matTooltip="{{ isSideMenuOpened ? null: 'siteMenu.account.groupName' | translate }}"
               matTooltipClass="sidenav-tooltip"
               matTooltipPosition="right">
                <!--<mat-icon>account_box</mat-icon>-->
                <img *ngIf="!accountMenuActive && !showAccount"
                     alt="account"
                     class="menu-icon"
                     height="21"
                     id="accountIcon_default"
                     ngSrc="assets/icons/account_default.svg"
                     width="20"/>
                <img *ngIf="accountMenuActive || showAccount"
                     alt="account"
                     class="menu-icon"
                     height="20"
                     ngSrc="assets/icons/account_active.svg"
                     width="20"/>
                <span class=""> {{ 'siteMenu.account.groupName'|translate }} </span> </a>
            <ul [class.active]="showAccount"
                class="sidebar-submenu">
                <li *ngIf="userRoutes?.UserSettings"
                    [ngClass]="{active : this.router.url.includes('user-settings')}"
                    tabindex="0">
                    <a routerLink="/user-settings">
                        {{ 'siteMenu.account.userSettings'|translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.CompanyProfile"
                    [ngClass]="{active : this.router.url.includes('company-profile')}"
                    tabindex="0">
                    <a routerLink="/company-profile">
                        {{ 'siteMenu.account.companyProfile'|translate }}
                    </a>
                </li>
                <li *ngIf="userRoutes?.ManageUsers"
                    [ngClass]="{active : this.router.url.includes('manage-users')}"
                    tabindex="0">
                    <a routerLink="/manage-users">
                        {{ 'siteMenu.account.manageUsers' | translate }}
                    </a>
                </li>
                <!-- <li [ngClass]="{active : this.router.url.includes('rewardship')}" tabindex="0"
                    *ngIf="userRoutes?.RewardShip">
                    <a routerLink="/rewardship">
                        {{ 'siteMenu.account.rewardShip' | translate }}
                    </a>
                </li> -->
                <li *ngIf="userRoutes?.DWRewardShip && !isEUUser()"
                    [ngClass]="{active : this.router.url.includes('dw-rewardship')}"
                    tabindex="0">
                    <a routerLink="/dw-rewardship">
                        {{ 'siteMenu.account.rewardShip' | translate }}
                    </a>
                </li>

                <li *ngIf="userRoutes?.NotifyTemplates"
                    [ngClass]="{active : this.router.url.includes('notify-templates')}"
                    tabindex="0">
                    <a routerLink="/notify-templates">
                        {{ 'siteMenu.account.manageNotifyTemplates' | translate }}
                    </a>
                </li>
            </ul>
        </li>

        <li class="sidebar-menu-wrapper"
            tabindex="0">
            <a (click)="ShowSupport($event)"
               *ngIf="showSupportNav()"
               [class.opened]="showSupport"
               [ngClass]="{'active-menu': supportMenuActive}"
               class="has-submenu"
               matTooltip="{{ isSideMenuOpened ? null: 'siteMenu.support.groupName' | translate }}"
               matTooltipClass="sidenav-tooltip"
               matTooltipPosition="right">
                <!--<mat-icon>help_outline</mat-icon>-->
                <img *ngIf="!supportMenuActive && !showSupport"
                     alt="support"
                     class="menu-icon"
                     height="21"
                     id="supportIcon_default"
                     ngSrc="assets/icons/support_default.svg"
                     width="22"/>
                <img *ngIf="supportMenuActive || showSupport"
                     alt="support"
                     class="menu-icon"
                     height="20"
                     ngSrc="assets/icons/support_active.svg"
                     width="20"/>
                <span class="sidebar-menu-label">
                    <span class="label-text">{{ 'siteMenu.support.groupName'|translate }}</span>
                </span>
            </a>
            <ul [class.active]="showSupport"
                class="sidebar-submenu">
                <li *ngIf="userRoutes?.SupplyOrder"
                    [ngClass]="{active : this.router.url.includes('supply-order')}"
                    tabindex="0">
                    <a routerLink="/support/supply-order">
                        {{ 'siteMenu.support.orderSupplies'|translate }}
                    </a>
                </li>
                <li [ngClass]="{active : this.router.url.includes('restricted-zip-codes')}"
                    tabindex="0">
                    <a *ngIf="userRoutes?.RestrictedZipCodes"
                       routerLink="/support/restricted-zip-codes">
                        {{ 'siteMenu.support.restrictedZipCodes'|translate }}
                    </a>
                </li>
                <li [ngClass]="{active : this.router.url.includes('support-documents')}"
                    tabindex="0">
                    <a *ngIf="userRoutes?.SupportDocuments"
                       routerLink="/support/support-documents">
                        {{ 'siteMenu.support.supportDocuments'|translate }}
                    </a>
                </li>
                <!-- <li *ngIf="!isDEGBUser()">
                    <a href="https://www.parcelpro.com/referral/" target="_blank">
                        {{'siteMenu.support.referrals'|translate}}
                    </a>
                </li> -->
                <li tabindex="0">
                    <form #ssoForm
                          action="{{ ssoURL }}"
                          method="post"
                          target="_blank">
                        <a (click)="generateSupportLink($event, ssoForm)"
                           *ngIf="userRoutes?.FAQs"
                           href="#">
                            {{ 'siteMenu.support.helpCenter'|translate }}
                        </a>
                    </form>
                </li>
                <li [ngClass]="{active : this.router.url.includes('contact-us')}"
                    tabindex="0">
                    <a *ngIf="userRoutes?.ContactUs"
                       routerLink="/support/contact-us">
                        {{ 'siteMenu.support.contactUs'|translate }}
                    </a>
                </li>
            </ul>
        </li>

        <li class="sidebar-menu-wrapper"
            tabindex="0">
            <a (click)="logout($event)"
               class="logout"
               href="#"
               matTooltip="{{ isSideMenuOpened ? null: 'siteMenu.logout' | translate }}"
               matTooltipClass="sidenav-tooltip"
               matTooltipPosition="right">
                <!--<mat-icon>power_settings_new</mat-icon>-->
                <img alt="logout"
                     class="menu-icon"
                     height="22"
                     ngSrc="assets/icons/logout_default.svg"
                     width="22"/>
                <span>{{ 'siteMenu.logout' | translate }}</span>
            </a>
        </li>
    </ul>

    <div class="sidebar-footer">
        <!--<mat-icon [matMenuTriggerFor]="sidebarFooterMenu" class="sidebar-footer-menu-trigger">help_outline</mat-icon>-->
        <div class="help-icon-wrapper">
            <img [matMenuTriggerFor]="sidebarFooterMenu"
                 alt="help"
                 class="sidebar-footer-menu-trigger"
                 height="19"
                 ngSrc="assets/icons/help.svg"
                 width="19">
        </div>
        <mat-menu #sidebarFooterMenu="matMenu"
                  class="sidebar-footer-menu">
            <a (click)="openTermsAndConditionsDialog($event)"
               href="#"
               mat-menu-item>
                {{ 'sidebar.footer.links.termsConditions' | translate }}</a>
            <a *ngIf="isDEGBUser()"
               href="{{ 'sidebar.footer.links.websiteTermsOfUseLink' | translate }}"
               mat-menu-item
               target="_blank">
                {{ 'sidebar.footer.links.websiteTermsOfUse' | translate }} </a>
            <a *ngIf="!isDEGBUser()"
               href="https://upscapital.com/privacy-notice/"
               mat-menu-item
               target="_blank">
                {{ 'sidebar.footer.links.privacy' | translate }}</a>
            <a (click)="openPrivacyDialog($event)"
               *ngIf="isDEGBUser()"
               href="#"
               mat-menu-item
               target="_blank">
                {{ 'sidebar.footer.links.privacy' | translate }}</a>
            <!-- MV3-4410 <a mat-menu-item href="#" (click)="openTermsOfUseDialog($event)" *ngIf="shouldShowTermsOfUse">
                {{ 'sidebar.footer.links.termsOfUse' | translate }}</a> -->
            <a class="emphasized"
               mat-menu-item
               routerLink="/support/contact-us">
                {{ 'sidebar.footer.links.contactUs' | translate }}</a>
            <a (click)="openImprintDialog($event)"
               *ngIf="isDEUser()"
               href="#"
               mat-menu-item>
                {{ 'sidebar.footer.links.imprint' | translate }}</a>
            <a (click)="openComplaintsDialog($event)"
               *ngIf="isDEGBUser()"
               href="#"
               mat-menu-item>
                {{ 'sidebar.footer.links.complaints' | translate }}</a>
            <!-- <a mat-menu-item href="#" (click)="openDisclaimerDialog($event)" *ngIf="isGBUser()" >
                    {{ 'sidebar.footer.links.disclaimer' | translate }} </a> -->
            <a (click)="openInternationalProductDisclosureDialog($event)"
               *ngIf="isDEGBUser()"
               href="#"
               mat-menu-item>
                {{ 'sidebar.footer.links.internationalProductDisclosure' | translate }}
            </a>
            <a *ngIf="!isDEGBUser()"
               [innerHtml]="'Your California Privacy Rights'"
               href="https://www.ups.com/us/en/help-center/legal-terms-conditions/california-privacy.page"
               mat-menu-item
               target="_blank"></a>
            <a *ngIf="!isDEGBUser()"
               [innerHtml]="'Do Not Sell or Share My Personal Informartion'"
               href="https://www.ups.com/ppwa/doWork?loc=en_US"
               mat-menu-item
               target="_blank"></a>
            <a href="javascript:utag.gdpr.showConsentPreferences();window.scrollTo(0,0);"
               mat-menu-item
               title="Cookie Consent">{{ 'sidebar.footer.links.cookieSettings' | translate }}
            </a>
        </mat-menu>

        <div *ngIf="isGB"
             class="links">
            <a (click)="openTermsAndConditionsDialog($event)"
               class="link"
               href="#">
                {{ 'sidebar.footer.links.termsConditions' | translate }}</a>
            <a class="link "
               href="https://upscapital.com/gb-en/international-technology-agreement/"
               target="_blank">{{
                    'sidebar.footer.links.technologyAgreement' |translate }}</a>
            <a class="link"
               href="https://www.ups.com/gb/en/support/shipping-support/legal-terms-conditions.page"
               target="_blank">
                {{ 'sidebar.footer.links.websiteTermsOfUse' | translate }} </a>
            <a class="link"
               href="https://upscapital.com/gb-en/product-disclosures/"
               target="_blank">
                {{ 'sidebar.footer.links.internationalProductDisclosure' | translate }} </a>
            <a class="link"
               href="https://upscapital.com/gb-en/complaints/"
               target="_blank">
                {{ 'sidebar.footer.links.complaints' | translate }} </a>

            <a class="link"
               href="https://upscapital.com/gb-en/privacy-notice/"
               target="_blank">
                {{ 'sidebar.footer.links.privacy' | translate }}</a>
            <a (click)="showConsentPreferences()"
               class="link"
               title="Cookie Consent">{{ 'sidebar.footer.links.cookieSettings' | translate }}</a>
            <a class="link"
               routerLink="/support/contact-us">
                {{ 'sidebar.footer.links.contactUs' | translate }}</a>
            <div class="copyright">{{ 'sidebar.footer.links.copyrights' | translate: { currentYear: currentYear } }}</div>
        </div>
        <div *ngIf="isFR || isIT || isDE"
             class="links">
            <a (click)="openTermsAndConditionsDialog($event)"
               class="link"
               href="#">
                {{ 'sidebar.footer.links.termsConditions' | translate }}</a>
            <a (click)="technologyAgreement($event)"
               *ngIf="isFR || isIT || isDE"
               class="link"
               href="#"
               target="_blank">{{
                    'sidebar.footer.links.technologyAgreement' | translate }}</a>
            <a (click)="websiteTermsOfUse($event)"
               class="link"
               href="#"
               target="_blank">
                {{ 'sidebar.footer.links.websiteTermsOfUse' | translate }} </a>
            <a (click)="internationalProductDisclosure($event)"
               class="link"
               href="#"
               target="_blank">
                {{ 'sidebar.footer.links.internationalProductDisclosure' | translate }}</a>
            <a (click)="complaints($event)"
               class="link"
               href="#"
               target="_blank">
                {{ 'sidebar.footer.links.complaints' | translate }} </a>
            <a (click)="impressum($event)"
               *ngIf="isDE"
               class="link"
               href="#"
               target="_blank">
                Impressum</a>
            <a (click)="privacy($event)"
               class="link"
               href="#"
               target="_blank">
                {{ 'sidebar.footer.links.privacy' | translate }}</a>
            <a (click)="showConsentPreferences()"
               class="link"
               title="Cookie Consent">{{ 'sidebar.footer.links.cookieSettings' | translate }}</a>
            <a class="link"
               routerLink="/support/contact-us">
                {{ 'sidebar.footer.links.contactUs' | translate }}</a>
            <div class="copyright">{{ 'sidebar.footer.links.copyrights' | translate: { currentYear: currentYear } }}</div>
        </div>

        <!-- isUS                 -->
        <div *ngIf="isUS"
             class="links">
            <a (click)="openTermsAndConditionsDialog($event)"
               class="link"
               href="#"
               target="_blank">
                {{ 'sidebar.footer.links.termsConditions' | translate }}</a>

            <a class="link"
               href="https://www.parcelpro.com/us/en/legal/website-terms-of-use.html"
               target="_blank">
                {{ 'sidebar.footer.links.websiteTermsOfUse' | translate }} </a>
            <a class="link "
               href="https://www.parcelpro.com/us/en/legal/technology-agreement.html"
               target="_blank">{{
                    'SignInPage.Footer.TechnologyAgreement' |
                        translate }}</a>
            <a class="link "
               href="https://www.parcelpro.com/us/en/legal/product-disclosure.html"
               target="_blank"> {{
                    'contactusUS.footer.productDisclosure' | translate }}</a>

            <a (click)="openComplaintsURL($event)"
               *ngIf="isDEGBUser()"
               class="link"
               href="#">
                {{ 'sidebar.footer.links.complaints' | translate }}</a>

            <a (click)="openLegalNoticeURL($event)"
               *ngIf="isDEUser()"
               class="link"
               href="#">
                {{ 'sidebar.footer.links.imprint' | translate }}</a>

            <a (click)="openProductDisclosureURL($event)"
               *ngIf="isDEGBUser()"
               class="link"
               href="#">
                {{ 'sidebar.footer.links.internationalProductDisclosure' | translate }}
            </a>
            <a *ngIf="!isDEGBUser()"
               [innerHtml]="'Your California Privacy Rights'"
               class="link"
               href="https://www.ups.com/us/en/support/shipping-support/legal-terms-conditions/california-privacy-rights"
               target="_blank"></a>
            <a class="link"
               href="https://www.parcelpro.com/us/en/legal/privacy-notice.html"
               target="_blank">
                {{ 'sidebar.footer.links.privacy' | translate }}</a>
            <a class="link"
               href="javascript:utag.gdpr.showConsentPreferences();window.scrollTo(0,0);"
               title="Cookie Consent">{{ 'sidebar.footer.links.cookieSettings' | translate }}</a>

            <a *ngIf="!isDEGBUser()"
               [innerHtml]="'Do Not Sell or Share My Personal Information'"
               class="link"
               href="https://www.ups.com/ppwa/doWork?loc=en_US"
               target="_blank"></a>
            <a class="link"
               routerLink="/support/contact-us">
                {{ 'sidebar.footer.links.contactUs' | translate }}</a>
        </div>
        <div *ngIf="isUS"
             class="copyright">{{ 'sidebar.footer.links.copyrights' | translate: { currentYear: currentYear } }}
        </div>

        <!-- <div *ngIf="!isUS" class="copyright">
            &copy; {{ getCurrentYear() }} United Parcel Service of America, Inc.<br>All rights reserved.
        </div> -->
    </div>

    <upsc-element-blocker *ngIf="isMenuLoading"
                          [theme]="'dark'"></upsc-element-blocker>
</div>
<div (click)="ToggleClass()"
     class="ui-blocker"
     id="ui-blocker"></div>
